/**
 * Shared API URL configuration.
 * Automatically replaces 'localhost' with the browser's hostname
 * so the app works from other devices on the same network.
 */
const API_URL = (process.env.REACT_APP_API_URL || 'http://localhost:8000').replace('localhost', window.location.hostname);

export default API_URL;
